import React from 'react';
import Chip from '@mui/material/Chip';
import ClearIcon from '@mui/icons-material/Clear';

const ReceiverChip = ({ value, onClick, isDisabled = false }) => (
  <Chip
    sx={{ xs: { padding: '20px', width: '100%' }, sm: { maxWidth: '100%', overflow: 'hidden' } }}
    label={value}
    icon={isDisabled ? undefined : <ClearIcon />}
    onClick={isDisabled ? () => {} : onClick}
  />
);

export default ReceiverChip;
